import { slideDownUp } from "src/app/shared/animations";
import { Component } from "@angular/core";
import { PicklistType } from "src/app/shared/enums/picklist-types";

@Component({
  selector: "app-picklist",
  templateUrl: "./picklist-page.component.html",
  animations: [slideDownUp],
  standalone: false,
})
export class PickListComponent {
  typeList = [PicklistType.Service, PicklistType.Language, PicklistType.Application, PicklistType.Testemonial];
  titleList = ["Categories", "Languages", "Applications", "Testemonials"];
  accordion: number | undefined = 1;

  updateAccordion(newRow: number | undefined) {
    this.accordion = newRow;
  }
}
